import k from '../constants/k'
import type { GameObj } from 'kaplay'
import { w } from '../state/globals'
import { initializeIngredients } from './ingredient'

k.loadSprite('inventory', 'sprites/ui/inventory.png', {
  sliceX: 2,
  anims: {
    default: 0
  }
})

export default (cursor: GameObj) => {
  const inventory: Array<GameObj> = []
  const inventorySize = 5

  for (let i = 0; i < inventorySize; i++) {
    const slotSize = 20
    const gap = 6
    const barWidth = inventorySize * slotSize + (inventorySize - 1) * gap
    const startX = (w - barWidth) / 2 + slotSize / 2
    const x = i * (slotSize + gap)

    const slot = k.add([
      k.sprite('inventory'),
      k.pos(x + startX, 6 + slotSize / 2),
      k.area(),
      k.scale(1),
      k.anchor('center')
    ])
    inventory.push(slot)

    slot.onHover(() => {
      cursor.play('pointer')
      slot.scale = k.vec2(1.1)
    })
    slot.onHoverEnd(() => {
      cursor.play('default')
      slot.scale = k.vec2(1)
    })
  }

  initializeIngredients(inventory, cursor)

  return inventory
}
